export default __webpack_public_path__ + "static/media/GovNpoSciQuestionnaire.7cd46337.pdf";